// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2OGmR","container":"styles_container__1NMqj","title":"styles_title__2Aqv2","wrapper":"styles_wrapper__3kIRN","answer":"styles_answer__22y2v"};